'use client';
import cn from 'classnames';
import styles from './TabSwitcher.module.scss';
import { ReactNode, useState } from 'react';

type TabType = {
  id: string;
  title: string;
  content?: ReactNode;
  count?: number;
  onClick?: () => void;
};

type TabSwitcherProps = {
  className?: string;
  tabs: TabType[];
};

export function TabSwitcher({ className, tabs }: TabSwitcherProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const handleTabClick = (tab: TabType) => {
    setActiveTab(tab);
    tab.onClick?.();
  };

  return (
    <div className={wrapperClassName}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <div
            className={cn(styles.tab, {
              [styles.active]: activeTab.id === tab.id,
            })}
            key={tab.id}
            onClick={() => handleTabClick(tab)}
          >
            {tab.title} {tab.count && `(${tab.count})`}
          </div>
        ))}
      </div>
      {activeTab.content && activeTab.content}
    </div>
  );
}
